<div class="ac-header-box-container">
    <div class="ac-header-inner-box-container">
        <ng-container *ngIf="loadingSales; else salesBox">
            <loader [size]="'large'"></loader>
        </ng-container>
        <ng-template #salesBox>
            <ng-container *ngIf="noData; else salesData">
                <div>No Sales Data Available</div>
            </ng-container>
            <ng-template #salesData><sales-opportunity-box [currPageState]="currPageState"
                    [dollarValue]="totalOpportunitySales">
                </sales-opportunity-box>
            </ng-template>
        </ng-template>
    </div>
    <div class="ac-header-inner-box-container">
        <ng-container *ngIf="loadingTVD; else TVDBox">
            <loader [size]="'large'"></loader>
        </ng-container>
        <ng-template #TVDBox>
            <ng-container *ngIf="noData; else TVDData">
                <div>No TVD Data Available</div>
            </ng-container>
            <ng-template #TVDData>
                <app-tvd-box [currPageState]="currPageState" [currentTVD]="currentTVD"
                    [opportunitiesTVD]="opportunityTVD" [totalOpportunityTVD]="totalOpportunityTVD"
                    [totalCurrentTVD]="totalCurrentTVD" [tvdDeltaPercent]="tvdDeltaPercent">
                </app-tvd-box>
            </ng-template>
        </ng-template>
    </div>
</div>